/*
  Customize how array inputs are rendered
  https://react-jsonschema-form.readthedocs.io/en/latest/advanced-customization/#array-field-template
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/atoms';
import styled from 'styled-components/macro';

function FieldArray({
  className, items, canAdd, onAddClick, title,
}) {
  return (
    <div className={className}>
      {items
        && items.map(element => (
          <Item key={element.index} tabIndex={0}>
            <div>{element.children}</div>
            <Actions>
              {element.hasMoveUp && (
                <Button
                  type="button"
                  icon="arrow-upward"
                  modifiers={['small', 'marginRight', 'marginTop', 'light']}
                  onClick={element.onReorderClick(
                    element.index,
                    element.index - 1
                  )}
                >
                  Up
                </Button>
              )}
              {element.hasMoveDown && (
                <Button
                  type="button"
                  modifiers={['small', 'marginRight', 'marginTop', 'light']}
                  icon="arrow-downward"
                  onClick={element.onReorderClick(
                    element.index,
                    element.index + 1
                  )}
                >
                  Down
                </Button>
              )}
              <Button
                modifiers={['small', 'danger', 'marginRight', 'marginTop']}
                type="button"
                onClick={element.onDropIndexClick(element.index)}
              >
                Delete
              </Button>
            </Actions>
          </Item>
        ))}

      {canAdd && (
        <WrapperAdd>
          <Button
            modifiers={['small', 'primary', 'marginRight', 'marginTop']}
            onClick={onAddClick}
            type="button"
            icon="add"
          >
            Add
            {' '}
            {title}
          </Button>
        </WrapperAdd>
      )}
    </div>
  );
}

FieldArray.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  canAdd: PropTypes.bool,
  onAddClick: PropTypes.func,
  title: PropTypes.string.isRequired,
};

FieldArray.defaultProps = {
  className: '',
  canAdd: true,
  onAddClick: () => null,
};

const Item = styled.div`
  padding: 0 ${props => props.theme.spacing.xs3};
  border: ${props => props.theme.values.borderSize} solid
    ${props => props.theme.colors.borderLighter};
  &:focus {
    border: ${props => props.theme.values.borderSize} solid
      ${props => props.theme.colors.primary};
    outline: 0;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${props => props.theme.spacing.xs3} 0;
`;

const WrapperAdd = styled.div`
  display: flex;
  margin-top: ${props => props.theme.spacing.xs};
`;

export default FieldArray;
